webpackJsonp([16],{

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receiptPage_vue__ = __webpack_require__(1108);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7385da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receiptPage_vue__ = __webpack_require__(1176);
function injectStyle (ssrContext) {
  __webpack_require__(1174)
}
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receiptPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7385da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receiptPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_constant_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_constant_js__);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "receiptPage",

  data: function data() {
    return {
      project: __WEBPACK_IMPORTED_MODULE_1__helper_constant_js__["PROJECT"],
      token: null,
      dataKeys: {},
      ReserveID: ""
    };
  },
  created: function created() {
    this.ReserveID = window.localStorage.getItem("ReserveID");
  },
  mounted: function mounted() {
    this.token = this.$route.query.resultIndicator;
    this.getBookingDetails();
  },

  methods: {
    getBookingDetails: function getBookingDetails() {
      var _this = this;

      var payload = {
        ReserveID: this.ReserveID || 16090,
        PaymentID: this.project == "ticketak" ? 4 : 2,
        SuccessIndicator: this.token
      };
      Object(__WEBPACK_IMPORTED_MODULE_0__helper_internet_js__["makeRequest"])("/ConfirmBooking", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        if (!error && res.data.Status) {
          _this.$router.push({
            name: "confirmBooking",
            params: { bookingId: res.data.BookingID }
          });
        } else {
          window.location.pathname = "/failedPayment";
          console.log("error from res", res.message);
        }
      }).catch(function (error) {
        window.location.pathname = "/failedPayment";
        console.log("Error on vue front", error);
      });
    }
  }
});

/***/ }),

/***/ 1174:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1175);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1039)("70fd39ee", content, true, {});

/***/ }),

/***/ 1175:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1038)(true);
// imports


// module
exports.push([module.i, ".paypro{height:50vh}", "", {"version":3,"sources":["/var/www/html/wanasa/website/vue-pwa-initial-setup/src/components/pages/receiptPage.vue"],"names":[],"mappings":"AACA,QACE,WAAa,CACd","file":"receiptPage.vue","sourcesContent":["\n.paypro {\n  height: 50vh;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center paypro"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"spinner loading"}),_vm._v(" "),_c('div',{staticClass:"error-text"},[_vm._v("Processing Payment...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/16.6a439888d089b7bcfa7b.js